import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { Theme as theme } from '@spoiler-alert/ui-library';

const styles = {
  plus: {
    display: 'inline-block',
    height: 13,
    width: 13,
    position: 'relative',
    top: 2,
    borderRadius: 2,
    marginRight: 6,
    backgroundColor: theme.teal,
    transition: 'background-color .3s',
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 3,
      left: 6,
      backgroundColor: theme.white,
      width: 1,
      height: 7,
    },
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 6,
      left: 3,
      backgroundColor: theme.white,
      width: 7,
      height: 1,
    },
    '&.naked': {
      marginRight: 0,
      backgroundColor: 'transparent',
      '&:before, &:after': {
        backgroundColor: theme.teal,
      },
    },
  },
  button: {
    color: theme.teal,
    lineHeight: '16px',
    height: 16,
    cursor: 'pointer',
    transition: 'color .3s',
    whiteSpace: 'nowrap',
    '&:hover': {
      color: theme.tealDark,
      '& $plus': {
        backgroundColor: theme.tealDark,
      },
      '& $plus.naked': {
        backgroundColor: 'transparent',
        '&:before, &:after': {
          backgroundColor: theme.tealDark,
        },
      },
    },
  },
};

// Module-level no-op default; the JSDoc type keeps the inferred prop signature permissive for TypeScript callers
/** @type {(...args: any[]) => void} */
const noop = () => {};

const NewButton = ({ classes, children, onClick = noop, naked = false }) => (
  <a className={classes.button} onClick={onClick}>
    <span className={`${classes.plus} ${naked ? 'naked' : ''}`} />
    {children}
  </a>
);

NewButton.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.string,
  onClick: PropTypes.func,
  naked: PropTypes.bool,
};

export default injectSheet(styles)(NewButton);
